import { currencySymbols } from './currencySymbols.js';

export function formatPrice(price, preferredCurrency = 'USD', exchangeData) {
  if (price === null || price === undefined || Number.isNaN(Number(price))) {
    return '';
  }

  const numericPrice = Number(price);

  // Get symbol for the preferred currency
  const symbol = currencySymbols[preferredCurrency] || '';

  // If USD or no exchange rate available, format original price to 2 decimals
  if (preferredCurrency === 'USD' || !exchangeData?.rates?.[preferredCurrency]) {
    return `${symbol}${numericPrice.toFixed(2)}`;
  }

  // Convert to preferred currency and include the symbol
  const convertedPrice = (numericPrice * exchangeData.rates[preferredCurrency]).toFixed(2);

  return `${symbol}${convertedPrice}`;
}
